import { h } from 'preact';
import { useSwatchMap } from '../../hooks/useSwatchMap';
import styles from './ColorSwatch.module.scss';
export function ColorSwatch({ options, onChange }) {
    const { getSwatchByDisplayName } = useSwatchMap();
    return (h("div", { class: styles.colorSwatchList }, options.map(option => {
        const swatchData = getSwatchByDisplayName(option.label);
        return (h("label", { key: option.id, class: styles.colorSwatchLabel },
            h("input", { type: "checkbox", checked: option.selected, onChange: () => onChange(option.id) }),
            h("span", { class: styles.customColorCheckbox, style: (swatchData === null || swatchData === void 0 ? void 0 : swatchData.colourCode) ? { backgroundColor: swatchData.colourCode } : undefined }),
            h("span", { class: styles.colorSwatchText }, option.label)));
    })));
}
